// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QDxNk","placeholdersHeader":"styles_placeholdersHeader__3DvNd","editorStyle":"styles_editorStyle__e1AVy","placeholdersBox":"styles_placeholdersBox__3TspE"};